export default __webpack_public_path__ + "static/media/1901.ca5e804d.png";